import { render, staticRenderFns } from "./order-coupon.vue?vue&type=template&id=46310c64&scoped=true"
import script from "./order-coupon.vue?vue&type=script&lang=js"
export * from "./order-coupon.vue?vue&type=script&lang=js"
import style0 from "./order-coupon.vue?vue&type=style&index=0&id=46310c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46310c64",
  null
  
)

export default component.exports